import { Injectable, inject } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FormSelectItem} from '../model/form/select-item.model';
import {
    DialogSelectYoungInscriptionDuplicateComponent
} from '../utils/dialog/dialog-select-young-inscription-duplicate/dialog-select-young-inscription-duplicate.component';
import {
    DialogSelectYoungInscriptionFamilyComponent
} from '../utils/dialog/dialog-select-young-inscription-family/dialog-select-young-inscription-family.component';
import {DialogConfirmComponent} from '../utils/dialog/dialog-confirm/dialog-confirm.component';
import {DialogDefaultComponent} from '../utils/dialog/dialog-default/dialog-default.component';
import {DialogRgpdAcceptComponent} from '../utils/dialog/dialog-rgpd-accept/dialog-rgpd-accept.component';
import {User} from '../model/user/user.model';
import {Year} from '../model/user/year.model';
import {DialogRightsComponent} from '../utils/dialog/dialog-rights/dialog-rights.component';
import {DialogAuthorisationComponent} from '../utils/dialog/dialog-authorisation/dialog-authorisation.component';
import {YoungViewModel} from '../components/young-info/young-info-view-model/YoungViewModel';
import {DialogAttestationComponent} from '../utils/dialog/dialog-attestation/dialog-attestation.component';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private readonly dialog = inject(MatDialog);


    confirm(
        title?: string,
        message?: string,
        yes?: string,
        no?: string) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogDefaultComponent, {
                data: {
                    title,
                    message,
                    no,
                    yes
                }
            });
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    confirmSimple(title?: string, message?: string) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogConfirmComponent, {
                data: {
                    title,
                    message
                }
            });
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    confirmRGPD(year: Year) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogRgpdAcceptComponent, {
                panelClass: 'dialog'
            });
            dialogRef.componentInstance.year = year;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    selectYoungDuplicate(listOfYoung: Array<FormSelectItem>) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogSelectYoungInscriptionDuplicateComponent, {
                data: {duplicates: listOfYoung},
                panelClass: 'dialog'
            });
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    selectYoungFamily(listOfFamily: Array<User>) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogSelectYoungInscriptionFamilyComponent, {
                data: {families: listOfFamily},
                panelClass: 'dialog-large'
            });
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    popupRightsAndAuthorisations(year: Year, young: YoungViewModel, isMinor: boolean, emptyForm = false) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogRightsComponent, {
                panelClass: 'dialog',
                autoFocus: false
            });
            dialogRef.componentInstance.year = year;
            dialogRef.componentInstance.isMinor = isMinor;
            dialogRef.componentInstance.young = young;
            dialogRef.componentInstance.emptyForm = emptyForm;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    popupAutorisationSport(young: YoungViewModel, isMinor = false) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogAuthorisationComponent, {
                panelClass: 'dialog',
                autoFocus: false
            });
            dialogRef.componentInstance.young = young;
            dialogRef.componentInstance.isSportDansLaVille = true;
            dialogRef.componentInstance.isMinor = isMinor;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    popupAutorisationJob(isMinor = false) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogAuthorisationComponent, {
                panelClass: 'dialog',
                autoFocus: false
            });
            dialogRef.componentInstance.isJobDansLaVille = true;
            dialogRef.componentInstance.isMinor = isMinor;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    popupAutorisationRdlv(young: YoungViewModel, isMinor = false) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogAuthorisationComponent, {
                panelClass: 'dialog',
                autoFocus: false
            });
            dialogRef.componentInstance.young = young;
            dialogRef.componentInstance.isRdlv = true;
            dialogRef.componentInstance.isMinor = isMinor;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }

    popupAttestation(young: YoungViewModel, isMinor = false) {
        return new Promise(resolve => {
            const dialogRef = this.dialog.open(DialogAttestationComponent, {panelClass: 'dialog'});
            dialogRef.componentInstance.young = young;
            dialogRef.componentInstance.isMinor = isMinor;
            dialogRef.afterClosed().subscribe(value => {
                resolve(value);
            });
        });
    }
}
